import React from 'react'
import { observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import MarkerLayer from './MarkerLayer'
import classnames from 'classnames'
import { inject } from 'mobx-react'

const UserMarkerfileLayer = ({ uiStore, selectionStore, markerfile }) => (
  <LayerGroup>
    {
      markerfile && markerfile.markers.map(marker => (
        <MarkerLayer
          key={marker.id}
          marker={marker}
          className={classnames({
            geopolygon: true,
            'leaflet-interactive': true,
            selected: true
          })}
        />
      ))
    }
  </LayerGroup>
)

export default inject('selectionStore', 'uiStore')(
  observer(UserMarkerfileLayer)
)
